export function handleApiError(error, defaultMessage = "Something went wrong. Please try again later.") {
  const status = error.response?.status;
  const data = error.response?.data;

  if (status === 422 && Array.isArray(data?.data)) {
    return { res: { data: data.data }, error_code: 1 };
  }

  if (status === 400) {
    return {
      error_code: 3,
      error_message: typeof data?.message === "string" ? data.message : defaultMessage,
      errors: data?.errors,
    };
  }

  if (status === 422) {
    return {
      error_code: 3,
      error_message: typeof data?.message === "string" ? data.message : defaultMessage,
      errors: data?.errors,
    };
  }

  return {
    error_code: 2,
    error_message: typeof data?.message === "string" ? data.message : error.message || defaultMessage,
  };
}

export const handleScopedListError = handleApiError;
